import { AuthService } from '@/services'
import auth from '@auth'
// eslint-disable-next-line import/no-cycle
import { getResponse } from '@/plugins/store'
/* eslint-disable import/no-cycle */
import store from '@/store'

export default {
  async login({ commit }, { params }) {
    commit('LOGIN_REQUEST')
    try {
      const { data } = await AuthService.login(params)
      auth.setToken(getResponse(data).id_token)
      commit('LOGIN_SUCCESS', getResponse(data).id_token)
    } catch (error) {
      commit('LOGIN_FAILURE', error)
    }
  },
  async register({ commit }, { params }) {
    commit('REGISTER_REQUEST')
    try {
      await AuthService.register(params)
      commit('REGISTER_SUCCESS')
    } catch (error) {
      commit('REGISTER_FAILURE', error)
    }
  },
  async trackingRegister({ commit }, params) {
    commit('TRACKING_REGISTER_REQUEST')
    try {
      await AuthService.trackingRegister(params)
      commit('TRACKING_REGISTER_SUCCESS')
    } catch (error) {
      commit('TRACKING_REGISTER_FAILURE', error)
    }
  },
  async getAccountInfo({ commit }) {
    commit('GET_ACCOUNT_INFO_REQUEST')
    try {
      const { data } = await AuthService.getAccountInfo()
      store.commit('adsAccount/SET_TIKTOK_ACCOUNT_CURRENT', getResponse(data) || {})
      commit('GET_ACCOUNT_INFO_SUCCESS', getResponse(data) || {})
      localStorage.setItem('userData', JSON.stringify(getResponse(data)))
    } catch (error) {
      commit('GET_ACCOUNT_INFO_FAILURE', error)
    }
  },
  async getAccountReport({ commit }) {
    commit('GET_ACCOUNT_REPORT_REQUEST')
    try {
      const { data } = await AuthService.getAccountReport()
      commit('GET_ACCOUNT_REPORT_SUCCESS', getResponse(data) || {})
    } catch (error) {
      commit('GET_ACCOUNT_REPORT_FAILURE', error)
    }
  },
  async resetInit({ commit }, params) {
    commit('RESET_INIT_REQUEST')
    try {
      await AuthService.resetInit(params)
      commit('RESET_INIT_SUCCESS')
    } catch (error) {
      commit('RESET_INIT_FAILURE', error)
    }
  },
  async resetFinish({ commit }, { params }) {
    commit('RESET_FINISH_REQUEST')
    try {
      await AuthService.resetFinish(params)
      commit('RESET_FINISH_SUCCESS')
    } catch (error) {
      commit('RESET_FINISH_FAILURE', error)
    }
  },

  async getGeneralConfig({ commit }) {
    commit('GET_GENERAL_CONFIG_REQUEST')
    try {
      const { data } = await AuthService.getGeneralConfig()
      commit('GET_GENERAL_CONFIG_SUCCESS', getResponse(data) || {})
    } catch (error) {
      commit('GET_GENERAL_CONFIG_FAILURE', error)
    }
  },

  async updateAccount({ commit }, params) {
    commit('UPDATE_ACCOUNT_REQUEST')
    try {
      await AuthService.updateAccount(params)
      commit('UPDATE_ACCOUNT_SUCCESS')
    } catch (error) {
      commit('UPDATE_ACCOUNT_FAILURE', error)
    }
  },
  async updatePassword({ commit }, params) {
    commit('UPDATE_PASSWORD_REQUEST')
    try {
      await AuthService.updatePassword(params)
      commit('UPDATE_PASSWORD_SUCCESS')
    } catch (error) {
      commit('UPDATE_PASSWORD_FAILURE', error)
    }
  },

  async verifyShopifyConnect({ commit }, params) {
    commit('VERIFY_SHOPIFY_CONNECT_REQUEST')
    try {
      const { data } = await AuthService.verifyShopifyConnect(params)
      commit('VERIFY_SHOPIFY_CONNECT_SUCCESS', getResponse(data))
    } catch (error) {
      commit('VERIFY_SHOPIFY_CONNECT_FAILURE', error)
    }
  },

  async requestVerifyEmail({ commit }) {
    commit('REQUEST_VERIFY_EMAIL')
    try {
      await AuthService.requestVerifyEmail()
      commit('REQUEST_VERIFY_EMAIL_SUCCESS')
    } catch (error) {
      commit('REQUEST_VERIFY_EMAIL_FAILURE', error)
    }
  },

  async getNotifications({ commit }, params) {
    // commit('GET_NOTIFICATIONS')
    try {
      const { data } = await AuthService.getNotifications(params)
      commit('GET_NOTIFICATIONS_SUCCESS', getResponse(data))
    } catch (error) {
      // commit('GET_NOTIFICATIONS_FAILURE', error)
    }
  },

  async readNotifications({ commit }, params) {
    commit('READ_NOTIFICATIONS')
    try {
      const { data } = await AuthService.readNotifications(params)
      commit('READ_NOTIFICATIONS_SUCCESS', getResponse(data))
    } catch (error) {
      commit('READ_NOTIFICATIONS_FAILURE', error)
    }
  },

  setIsAuthenticated({ state }, isAuth) {
    state.isAuthenticated = isAuth
  },

  logout() {
    auth.clearLocalStorage()
    if (process.env.VUE_APP_LOGIN_URL) {
      window.location.href = `${process.env.VUE_APP_LOGIN_URL}/logout?v=${new Date().getTime()}`
    } else {
      window.location.href = '/login'
    }
  },
}
